// Get image src from container's data-img-src attribute
const seafoodEl = document.getElementById('seafood');
const ballImgUrl = seafoodEl && seafoodEl.getAttribute('data-img-src');


// Create a Konva stage and add a layer
const stage = new Konva.Stage({
  container: 'seafood',
  width: window.innerWidth,
  height: 200,
});

const layer = new Konva.Layer();
stage.add(layer);

// Generate wave curve points
function getWavePoints(amplitude, wavelength, yOffset, pointsCount) {
  const points = [];
  const width = stage.width();
  for (let i = 0; i <= pointsCount; i++) {
    const x = (i / pointsCount) * width;
    const y = amplitude * Math.sin((2 * Math.PI * x) / wavelength) + yOffset;
    points.push(x, y);
  }
  return points;
}

const curveAmplitude = 16;
const curveWavelength = stage.width() / 3;
const curveYOffset = stage.height() - 100;
const curvePointsCount = 80;
const wavePoints = getWavePoints(curveAmplitude, curveWavelength, curveYOffset, curvePointsCount);

const waveLine = new Konva.Line({
  points: wavePoints,
  stroke: '#283f88',
  strokeWidth: 4,
  lineCap: 'round',
  lineJoin: 'round',
  tension: 0.6,
});
// Fill the bottom part of the canvas (beneath the wave curve) with #283f88 using a closed polygon

// Compute points for a closed shape covering the area below the wave
const bottomFillPoints = [...wavePoints];

// Add points for bottom-right corner and bottom-left corner to close the polygon
bottomFillPoints.push(
  stage.width(), stage.height(), // bottom right
  0, stage.height(),            // bottom left
  wavePoints[0], wavePoints[1]  // close to start point
);

const bottomFill = new Konva.Line({
  points: bottomFillPoints,
  fill: '#283f88',
  closed: true,
  stroke: null,
  lineCap: 'round',
  lineJoin: 'round',
  tension: 0.6,
});

layer.add(bottomFill);

layer.add(waveLine);

const ballRadius = 40;
let ball, ballImageLoaded = false;
let ballRotation = 0;
let previousX = null;

// Animation control flag
let isPaused = false;
let animationFrameId = null;

// For event handler attach: must set listening to true!
function setupBallEvents() {
  if (!ball) return;
  ball.listening(true);

  ball.on('mouseover', () => {
    isPaused = true;
  });

  ball.on('mouseout', () => {
    isPaused = false;
    animateBall();
  });
}

if (ballImgUrl) {
  const imageObj = new window.Image();
  imageObj.onload = function () {
    ball = new Konva.Image({
      x: wavePoints[0] - ballRadius,
      y: wavePoints[1] - ballRadius + 10,
      image: imageObj,
      width: ballRadius * 2,
      height: ballRadius * 2,
      // shadowColor: '#e47911',
      // shadowBlur: 18,
      // shadowOffset: { x: 0, y: 6 },
      // stroke: '#263a6e',
      // strokeWidth: 4,
      cornerRadius: ballRadius,
      listening: true, // IMPORTANT: enable events
      offset: {
        x: ballRadius,
        y: ballRadius,
      },
      rotation: ballRotation,
    });
    layer.add(ball);
    ballImageLoaded = true;
    setupBallEvents();
    animateBall();
  }
  imageObj.crossOrigin = 'Anonymous';
  imageObj.src = ballImgUrl;
} else {
  // fallback if no image, use orange circle for robustness
  ball = new Konva.Circle({
    x: wavePoints[0],
    y: wavePoints[1] - ballRadius + 10,
    radius: ballRadius,
    // fill: '#ff9a32',
    // shadowColor: '#e47911',
    // shadowBlur: 18,
    // shadowOffset: { x: 0, y: 6 },
    stroke: '#263a6e',
    strokeWidth: 4,
    listening: true, // enable events
  });
  layer.add(ball);
  ballImageLoaded = true;
  setupBallEvents();
  animateBall();
}

const totalPoints = wavePoints.length / 2;
let t = 0;
let direction = 1;

function animateBall() {
  if (!ballImageLoaded) return;
  if (isPaused) {
    animationFrameId = null;
    return;
  }

  if (t < 0) {
    t = 0;
    direction *= -1;
  } else if (t > totalPoints - 1) {
    t = totalPoints - 1;
    direction *= -1;
  }

  const idx = Math.floor(t);
  const frac = t - idx;

  let x, y;
  if (idx < totalPoints - 1) {
    const x1 = wavePoints[idx * 2];
    const y1 = wavePoints[idx * 2 + 1];
    const x2 = wavePoints[(idx + 1) * 2];
    const y2 = wavePoints[(idx + 1) * 2 + 1];
    x = x1 + (x2 - x1) * frac;
    y = y1 + (y2 - y1) * frac;
  } else {
    x = wavePoints[idx * 2];
    y = wavePoints[idx * 2 + 1];
  }

  // Calculate rotation for image ball
  if (previousX !== null) {
    const dx = x - previousX;
    // If moving right to left, rotate anti-clockwise (subtract)
    // If moving left to right, rotate clockwise (add)
    // rotation = traveled distance / radius (radians), then convert to deg
    const rotationDelta = (Math.abs(dx) / ballRadius) * (180 / Math.PI) * 0.9; // 0.9 multiplier to look natural
    if (dx > 0) {
      // Moving right, rotate clockwise
      ballRotation += rotationDelta;
    } else if (dx < 0) {
      // Moving left, rotate anti-clockwise
      ballRotation -= rotationDelta;
    }
    // If dx === 0, do nothing (no movement)
  }
  previousX = x;

  if (ball instanceof Konva.Image) {
    // Set center as offset
    ball.position({ x: x, y: y - ballRadius + 10 });
    ball.offset({ x: ballRadius, y: ballRadius });
    ball.rotation(ballRotation);
  } else {
    // Fallback: regular ball
    ball.x(x);
    ball.y(y - ballRadius + 10);
  }

  t += 0.18 * direction;

  layer.batchDraw();
  animationFrameId = requestAnimationFrame(animateBall);
}

window.addEventListener('resize', () => {
  stage.width(window.innerWidth);
  // re-calculate the curve for new width
  const newPoints = getWavePoints(curveAmplitude, stage.width() / 1.2, curveYOffset, curvePointsCount);
  waveLine.points(newPoints);

  const bottomFillPoints = [...newPoints];

  // Add points for bottom-right corner and bottom-left corner to close the polygon
  bottomFillPoints.push(
    stage.width(), stage.height(), // bottom right
    0, stage.height(),            // bottom left
    newPoints[0], newPoints[1]  // close to start point
  );
  bottomFill.points(bottomFillPoints);

  // Update reference for the wave the ball moves on
  for (let i = 0; i < newPoints.length; i++) {
    wavePoints[i] = newPoints[i];
  }
  layer.batchDraw();
});

// Only call animateBall if image fallback, otherwise image onload will call it
if (!(ballImgUrl)) {
  animateBall();
}
